// extracted by mini-css-extract-plugin
export default {"delimiter":"delimiter--m8tbD"};